<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <router-link to="/liquidaciones/clientes" class="pull-right">Volver a la lista</router-link>
      </div>
      <div class="row" v-if="liquidacion" ref="detalle">
        <div class="box-style line-top">
          <div class="form smart-form">
            <div class="box-header text-center">
              <h2 class="pull-left">Liquidacion N° {{liquidacion.numero}}</h2>
              <h2 class="text-center">{{liquidacion.empresa.empresa.razonSocial}} - {{liquidacion.empresa.denominacion}}</h2>
              <div class="box-date">
                <b>{{liquidacion.estado}}</b>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12 col-sm-4">
                  <p class="size-14">
                    <b>Cantidad de Entregas:</b>
                    {{liquidacion.entregas.length}}
                    <br>
                    <b>Emitida el:</b>
                    {{liquidacion.fechaCreacion | formatFecha}}
                    <br>
                    <b>Monto total de pedidos:</b>
                    {{montoTotalPedidos | formatMoneda}}
                  </p>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <p class="size-14">
                        <b>Monto total subsididado en pedidos:</b>
                        {{montoTotalSubsidiadoPedidos | formatMoneda}}
                        <br>
                        <b>Monto a pagar por usuarios:</b>
                        {{montoPagarUsuarios | formatMoneda}}
                        <br>
                    </p>
                </div>
                <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                  <label>Exportar Liquidación</label>
                  <br/>
                  <button class="btn btn-sm btn-outline-grey-green" @click="exportXls(false)">
                    EXCEL
                  </button>
                  <button class="btn btn-sm btn-outline-grey-green" @click="exportPdf(false)">
                    PDF
                  </button>
                </div>                
              </div>
              </div>

              <div class="row box-header">
                <div class="col-xs-12 col-sm-12">
                <div class="form-group col-xs-12 col-sm-3" style="padding-left:0;">
                  <label>EMPLEADO</label>
                  <br/>                  
                  <select class="form-control select2 filter-select2" ref="slUsuario" multiple style="width:100%" data-select2-container="big-text">
                    <option v-for="usuario in usuariosDistinct" :key="usuario._id" :value="usuario._id">{{usuario.displayName}}</option>
                  </select>
                  <a @click="quitarFiltrosEmpleado" class="disable-filter hide" :class="{show: filtros.empleados.length > 0}">Quitar filtro empleado</a>
                </div>
                <div class="form-group col-xs-12 col-sm-2" style="padding-left:0;">
                  <label>COMBO</label>
                  <br/>                  
                  <select class="form-control select2 filter-select2" ref="slCombo" multiple style="width:100%" data-select2-container="big-text">
                    <option v-for="combo in combos" :key="combo._id" :value="combo._id">{{combo.nombre}}</option>
                  </select>
                  <a @click="quitarFiltrosCombo" class="disable-filter hide" :class="{show: filtros.combos.length > 0}">Quitar filtro combos</a>
                </div>
                <div class="form-group col-xs-12 col-sm-3" style="padding-left:0;">
                  <label>DESDE</label>
                  <date-picker v-model="filtros.desde" :max-date="new Date()"></date-picker>
                  <!-- agregar class "show" para mostrar el link quitar filtro-->
                  <a href="#" class="disable-filter hide">Quitar filtro fecha</a>
                </div>
                <div class="form-group col-xs-12 col-sm-3" style="padding-left:0;">
                  <label>HASTA</label>
                  <date-picker v-model="filtros.hasta" :max-date="new Date()"></date-picker>
                  <!-- agregar class "show" para mostrar el link quitar filtro-->
                  <a href="#" class="disable-filter hide">Quitar filtro fecha</a>
                </div>                

                <div class="col-xs-12 col-sm-1" style="padding-left:0;">
                <div class="form-group">
                  <label>EXPORTAR SELECCIONADOS</label>
                  <br/>
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                          Exportar  <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a @click.prevent="exportXls(true)">EXCEL</a>
                          </li>
                          <li>
                            <a @click.prevent="exportPdf(true)">PDF</a>
                          </li>
                        </ul>
                      </div>
                </div>                

                </div>


                </div>
              </div>
              <div class="row">
              <br/>
                <div class="col-xs-12 col-sm-3">
                  <p class="size-14">
                    <b>Cantidad de Entregas:</b>
                    {{entregasFiltradas.length}}
                  </p>
                </div>
                <div class="col-xs-12 col-sm-3">
                  <p class="size-14">
                    <b>Monto total de pedidos:</b>
                    {{montoTotalPedidosFiltrados | formatMoneda}}
                  </p>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <p class="size-14">
                        <b>Monto total subsididado en pedidos:</b>
                        {{montoTotalSubsidiadoPedidosFiltrados | formatMoneda}}
                    </p>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <p class="size-14">
                        <b>Monto a pagar por usuarios:</b>
                        {{montoPagarUsuariosFiltrados | formatMoneda}}
                    </p>
                </div>
              </div>
              <div class="row">
                <div>
                    <ul class="nav nav-tabs" role="tablist">
                      <li role="presentation" class="active"><a href="#lista" aria-controls="lista" role="tab" data-toggle="tab">Lista de pedidos</a></li>
                      <li role="presentation"><a href="#usuarios" aria-controls="usuarios" role="tab" data-toggle="tab">Agrupada por usuarios</a></li>
                      <li role="presentation"><a href="#movimientos" aria-controls="movimientos" role="tab" data-toggle="tab">Movimientos</a></li>
                    </ul>
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane active" id="lista">
                            <table class="table">
                                <thead>
                                  <tr>
                                    <th>Número</th>
                                    <th>Pedido por</th>
                                    <th>Legajo</th>
                                    <th>Fecha entrega</th>
                                    <th class="text-right">Monto pedido</th>
                                    <th class="text-right">Monto subsidiado</th>
                                    <th class="text-right">Acciones</th>
                                  </tr>
                                </thead>
                                <tbody v-if="liquidacion.entregas.length > 0">
                                  <template v-for="entrega in entregasPaginadas">
                                    <tr>
                                      <td>{{entrega.numero}}</td>
                                      <td>{{entrega.usuario.displayName}}</td>
                                      <td>{{entrega.usuario.legajo}}</td>
                                      <td>{{entrega.fechaEntrega | formatFecha}}</td>
                                      <td class="text-right">{{entrega.montoBruto | formatMoneda}}</td>
                                      <td class="text-right">{{entrega.montoSubsidiado | formatMoneda}}</td>
                                      <td class="text-center">
                                        <button class="btn btn-link btn-xs" @click="entrega.verDetalle = !entrega.verDetalle">Ver detalle</button>
                                      </td>
                                    </tr>
                                    <tr v-if="entrega.verDetalle">
                                      <td colspan="5">
                                        <table class="table table-bordered">
                                          <tbody>
                                            <tr v-for="plato in entrega.platos">
                                              <td class="text-right">{{plato.cantidad}}x</td>
                                              <td colspan="3">{{plato.plato.nombre}}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                        <div class="smart-form" v-if="paginador.totalItems > 0">
                          <div class="text-center center-block">
                            <nav aria-label="Page navigation">
                              <ul class="pagination pagination-sm">
                              <li>
                                <a @click="goToPrevPage()"  aria-label="Anterior">
                                <span aria-hidden="true">«</span>
                                </a>
                              </li>
                              <li><span>Página {{paginador.currentPage}} de {{paginador.totalPages}}</span></li>
                              <li>
                                <a @click="goToNextPage()" aria-label="Siguiente">
                                <span aria-hidden="true">»</span>
                                </a>
                              </li>
                              </ul>
                            </nav>
                          </div>
                        </div>                                                      
                        </div>
                        <div role="tabpanel" class="tab-pane" id="usuarios">
                            <table class="table">
                                <thead>
                                  <tr>
                                    <th>Usuario</th>
                                    <th class="text-right">Pedidos</th>
                                    <th class="text-right">Monto total</th>
                                    <th class="text-right">Monto subsidiado</th>
                                    <th class="text-right">Monto pagado por usuario</th>
                                    <th>Acciones</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="entregasUsuario, idx in entregasAgrupadasUsuario" >   
                                    <tr :key="entregasUsuario.idUser">
                                      <td><span v-if="entregasUsuario.user.legajo">{{entregasUsuario.user.legajo}} - </span>{{entregasUsuario.user.displayName}}</td>
                                      <td class="text-right">{{entregasUsuario.entregas.length}}</td>
                                      <td class="text-right">{{entregasUsuario.entregas | montoTotal | formatMoneda}}</td>
                                      <td class="text-right">{{entregasUsuario.entregas | totalSubsidiadoUsuario | formatMoneda}}</td>
                                      <td class="text-right">{{entregasUsuario.entregas | totalPagadoUsuario | formatMoneda}}</td>
                                      <td>
                                          <button :key="entregasUsuario.idUser" class="btn btn-link btn-xs js-detalle" @click="entregasUsuario.mostrarDetalle = !entregasUsuario.mostrarDetalle">Ver detalle</button>
                                      </td>
                                    </tr>
                                    <tr :key="entregasUsuario.idUser" class="table-detalle hidden">
                                      <td colspan="6" style="background-color: #EEE;">
                                        <table class="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th>Número</th>
                                              <th>Fecha entrega</th>
                                              <th>Combo</th>
                                              <th class="text-right">Monto total</th>
                                              <th class="text-right">Monto subsididado</th>
                                              <th>Acciones</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template v-for="entrega in entregasUsuario.entregas">
                                              <tr>
                                                <td>{{entrega.numero}}</td>
                                                <td>{{entrega.fechaEntrega | formatFecha}}</td>
                                                <td>{{entrega.combo.nombre}}</td>
                                                <td class="text-right">{{entrega.montoBruto | formatMoneda}}</td>
                                                <td class="text-right">{{entrega.montoSubsidiado | formatMoneda}}</td>
                                                <td>
                                                    <button :key="entregasUsuario.idUser" class="btn btn-link btn-xs js-detalle">Ver detalle</button>
                                                </td>
                                              </tr>
                                              <tr class="hidden table-detalle">
                                                <td colspan="5">
                                                  <b>Platos del pedido {{entrega.numero}}: </b>{{entrega.platos | platosSerialized}}
                                                </td>
                                              </tr>
                                            </template>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>                              
                        </div>
                        <div class="tab-pane" role="tabpanel" id="movimientos">
                <h3 class="text-center">Movimientos registrados para la liquidación {{liquidacion.numero}}</h3>
                <table class="table">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Tipo</th>
                        <th>Comprobante</th>
                        <th class="text-right">Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="movimiento in movimientosFiltrados" :key="movimiento._id">
                        <td>{{movimiento.fecha | formatFecha}}</td>
                        <td>{{movimiento.tipo}}</td>
                        <td>{{movimiento.comprobante}}</td>
                        <td class="text-right">{{movimiento.importe | formatMoneda}}</td>
                      </tr>
                    </tbody>
                  </table>

                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden" ref="contenedorExport"></div>    
  </section>
</template>
<script>
  import '../../assets/css/select2_status.css'
  import '../../assets/css/select2.css'
  import moment from 'moment'
  import PHE from 'print-html-element'
  import {uniqBy, sortBy, groupBy} from 'lodash'
  import $ from 'jquery'
  import 'select2'
  import JsPDF from 'jspdf'
  import 'jspdf-autotable'
  import TableExport from 'tableexport'
  import DatePicker from '../Shared/DatePicker'

  export default {
    components: {
      'date-picker': DatePicker
    },
    data () {
      return {
        paginador: {
          pageSize: 10,
          currentPage: 1,
          totalItems: 0,
          totalPages: 0
        },
        liquidacion: null,
        movimientos: [],
        filtros: {
          desde: null,
          hasta: null,
          combos: [],
          empleados: []
        }
      }
    },
    computed: {
      entregasFiltradas () {
        const me = this
        let entregas = me.liquidacion.entregas
        if (me.filtros.desde) {
          entregas = entregas.filter((entrega) => {
            return new Date(entrega.fechaEntrega) >= moment(me.filtros.desde).startOf('day').toDate()
          })
        }
        if (me.filtros.hasta) {
          entregas = entregas.filter((entrega) => {
            return new Date(entrega.fechaEntrega) < moment(me.filtros.hasta).endOf('day').toDate()
          })
        }
        if (me.filtros.empleados.length > 0) {
          entregas = entregas.filter((entrega) => {
            return me.filtros.empleados.includes(entrega.usuario._id)
          })
        }
        if (me.filtros.combos.length > 0) {
          entregas = entregas.filter((entrega) => {
            return me.filtros.combos.includes(entrega.combo._id)
          })
        }
        me.paginador.totalItems = entregas.length
        me.paginador.totalPages = Math.ceil(me.paginador.totalItems / me.paginador.pageSize)
        return entregas
      },
      entregasPaginadas () {
        const me = this
        let desde = (me.paginador.currentPage - 1) * me.paginador.pageSize
        let hasta = me.paginador.currentPage * me.paginador.pageSize
        let filtrados = me.entregasFiltradas.filter((entrega, idx) => {
          return idx >= desde && idx < hasta
        })
        return filtrados
      },
      combos () {
        const me = this
        const combos = me.liquidacion.combosSubscriptos.map((combSubs) => {
          return combSubs.combo
        })
        return combos
      },
      usuariosDistinct () {
        const me = this
        let usuarios = me.liquidacion.entregas.map((entrega) => {
          return entrega.usuario
        })
        let usuariosDistinct = uniqBy(usuarios, (usuario) => {
          return usuario._id
        })
        return sortBy(usuariosDistinct, 'displayName')
      },
      entregasAgrupadasUsuario () {
        const me = this
        let resultado = []
        let entregas = me.liquidacion.entregas
        entregas = sortBy(entregas, (entrega) => {
          return entrega.fechaEntrega
        })
        let entregasAgrupadas = groupBy(entregas, (entrega) => {
          return entrega.usuario._id
        })
        for (let [k, v] of Object.entries(entregasAgrupadas)) {
          resultado.push({
            user: v[0].usuario,
            entregas: v,
            mostrarDetalle: false,
            idUser: k
          })
        }
        return resultado
      },
      montoTotalPedidos () {
        const me = this
        let valor = 0
        me.liquidacion.entregas.forEach((entrega) => {
          valor += parseFloat(entrega.montoBruto)
        })
        return valor
      },
      montoTotalSubsidiadoPedidos () {
        const me = this
        let valor = 0
        me.liquidacion.entregas.forEach((entrega) => {
          valor += parseFloat(entrega.montoSubsidiado)
        })
        return valor
      },
      montoPagarUsuarios () {
        const me = this
        return me.montoTotalPedidos - me.montoTotalSubsidiadoPedidos
      },
      montoTotalPedidosFiltrados () {
        const me = this
        let valor = 0
        me.entregasFiltradas.forEach((entrega) => {
          valor += parseFloat(entrega.montoBruto)
        })
        return valor
      },
      montoTotalSubsidiadoPedidosFiltrados () {
        const me = this
        let valor = 0
        me.entregasFiltradas.forEach((entrega) => {
          valor += parseFloat(entrega.montoSubsidiado)
        })
        return valor
      },
      montoPagarUsuariosFiltrados () {
        const me = this
        return me.montoTotalPedidosFiltrados - me.montoTotalSubsidiadoPedidosFiltrados
      },

      movimientosFiltrados () {
        return this.movimientos.filter((movimiento) => {
          return movimiento.esPago
        })
      }
    },
    filters: {
      totalItems () {
        return this.entregasFiltradas.length
      },
      totalPages () {
        return Math.ceil(this.totalItems / this.paginador.pageSize)
      },
      formatFecha (value) {
        return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
      },
      formatMoneda (value) {
        return '$' + parseFloat(value).toFixed(2)
      },
      montoTotal (entregas) {
        let valor = 0
        entregas.forEach((entrega) => {
          valor += parseFloat(entrega.montoBruto)
        })
        return valor
      },
      platosSerialized (platos) {
        return platos.map((plato) => {
          return `${plato.cantidad}x ${plato.plato.nombre}`
        }).join(' + ')
      },
      totalPagadoUsuario (entregas) {
        let valor = 0
        entregas.forEach((entrega) => {
          valor += parseFloat(entrega.montoBruto - entrega.montoSubsidiado)
        })
        return valor
      },
      totalSubsidiadoUsuario (entregas) {
        let valor = 0
        entregas.forEach((entrega) => {
          valor += parseFloat(entrega.montoSubsidiado)
        })
        return valor
      }
    },
    methods: {
      goToNextPage () {
        const me = this
        if (me.paginador.currentPage < me.paginador.totalPages) {
          me.paginador.currentPage += 1
        }
      },
      goToPrevPage () {
        const me = this
        if (me.paginador.currentPage > 1) {
          me.paginador.currentPage -= 1
        }
      },
      quitarFiltrosCombo () {
        const me = this
        me.filtros.combos = []
        $(me.$refs.slCombo).val(me.filtros.combos).trigger('change')
      },
      quitarFiltrosEmpleado () {
        const me = this
        me.filtros.empleados = []
        $(me.$refs.slUsuario).val(me.filtros.empleados).trigger('change')
      },
      cambiarVisibilidad (idx) {
        const me = this
        me.entregasAgrupadasUsuario[idx].mostrarDetalle = !me.entregasAgrupadasUsuario[idx].mostrarDetalle
        me.entregasAgrupadasUsuario.push({})
        me.entregasAgrupadasUsuario.pop({})
      },
      imprimir () {
        PHE.printElement(this.$refs.detalle)
      },
      exportXls (filtered) {
        const me = this
        let datos = { entregas: me.liquidacion.entregas, bruto: me.montoTotalPedidos, subsidiado: me.montoTotalSubsidiadoPedidos, total: me.montoTotalPedidos - me.montoTotalSubsidiadoPedidos }
        if (filtered) {
          datos = { entregas: me.entregasFiltradas, bruto: me.montoTotalPedidosFiltrados, subsidiado: me.montoTotalSubsidiadoPedidosFiltrados, total: me.montoTotalPedidosFiltrados - me.montoTotalSubsidiadoPedidosFiltrados }
        }
        let title = me.liquidacion.empresa.empresa.razonSocial + ' | Detalle de la liquidacion: '
        title += me.liquidacion.numero
        title += ' | Estado: '
        title += me.liquidacion.estado
        let subtitle = 'Cantidad de pedidos: ' + datos.entregas.length
        subtitle += ' | Monto total de pedidos: ' + '$' + parseFloat(datos.bruto).toFixed(2)
        subtitle += ' | Monto subsidiado: ' + '$' + parseFloat(datos.subsidiado).toFixed(2)
        subtitle += ' | Monto a pagar por usuarios:: ' + '$' + parseFloat(datos.total).toFixed(2)
        let html = `<table class="table" id="tblExport">
        <thead>
          <tr>
            <th colspan='6'>${title}</th>
          </tr>
          <tr>
            <th colspan='6'>${subtitle}</th>
          </tr>
          <tr>
            <th>Número</th>
            <th>Pedido por</th>
            <th>Legajo</th>
            <th>Fecha entrega</th>
            <th>Monto pedido</th>
            <th>Monto subsidiado</th>
          </tr>
        </thead>
        <tbody>
          ${me.entregasFiltradas.map(entrega => {
            return `<tr>
              <td>${entrega.numero}</td>
              <td>${entrega.usuario.displayName}</td>
              <td>${entrega.usuario.legajo ? entrega.usuario.legajo : ''}</td>
              <td>${moment(entrega.fechaEntrega).format('DD/MM/YYYY HH:mm')}</td>
              <td>${'$' + parseFloat(entrega.montoBruto).toFixed(2)}</td>
              <td>${'$' + parseFloat(entrega.montoSubsidiado).toFixed(2)}</td>
            </tr>`
          })
          }
        </tbody>
      </table>`
        $(me.$refs.contenedorExport).html(html)
        let table = document.getElementById('tblExport')
        let tableExp = new TableExport(table, {
          exportButtons: false,
          formats: ['xls', 'csv', 'txt', 'xlsx']
        })
        tableExp.types.date.assert = function (v) {
          return false
        }
        let exportData = tableExp.getExportData()
        tableExp.export2file(exportData.tblExport.xlsx.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'detalleLiquidacion-' + me.liquidacion.numero, '.xlsx')
      },
      exportPdf (filtered) {
        const me = this
        let datos = { entregas: me.liquidacion.entregas, bruto: me.montoTotalPedidos, subsidiado: me.montoTotalSubsidiadoPedidos, total: me.montoTotalPedidos - me.montoTotalSubsidiadoPedidos }
        if (filtered) {
          datos = { entregas: me.entregasFiltradas, bruto: me.montoTotalPedidosFiltrados, subsidiado: me.montoTotalSubsidiadoPedidosFiltrados, total: me.montoTotalPedidosFiltrados - me.montoTotalSubsidiadoPedidosFiltrados }
        }
        var img = new Image()
        img.src = '/images/bird.png'
        img.onload = function () {
          let title = me.liquidacion.empresa.empresa.razonSocial + ' | Detalle de la liquidacion: '
          title += me.liquidacion.numero
          title += ' | Estado: '
          title += me.liquidacion.estado
          let subtitle = 'Cantidad de pedidos: ' + datos.entregas.length
          subtitle += ' | Monto total de pedidos: ' + '$' + parseFloat(datos.bruto).toFixed(2)
          subtitle += ' | Monto subsidiado: ' + '$' + parseFloat(datos.subsidiado).toFixed(2)
          subtitle += ' | Monto a pagar por usuarios:: ' + '$' + parseFloat(datos.total).toFixed(2)
          const columns = ['Número', 'Pedido por', 'Legajo', 'Fecha entrega', 'Monto pedido', 'Monto subsidiado']
          const rows = datos.entregas.map((entrega) => {
            return [
              entrega.numero,
              entrega.usuario.displayName,
              entrega.usuario.legajo,
              moment(entrega.fechaEntrega).format('DD/MM/YYYY HH:mm'),
              '$' + parseFloat(entrega.montoBruto).toFixed(2),
              '$' + parseFloat(entrega.montoSubsidiado).toFixed(2)
            ]
          })
          const doc = new JsPDF('l')
          doc.autoTable(columns, rows, {
            margin: 25,
            bodyStyles: {
              overflow: 'visible',
              fontSize: 8,
              columnWidth: 'wrap'
            },
            headerStyles: {
              fillColor: [147, 165, 18]
            },
            addPageContent: function (data) {
              doc.addImage(img, 'PNG', 25, 10, 12, 12)
              doc.setFontSize(12)
              doc.text(title, 40, 14)
              doc.setFontSize(10)
              doc.text(subtitle, 40, 19)
            }
          })
          doc.save('detalleLiquidacion-' + me.liquidacion.numero + '.pdf')
        }
      }
    },
    mounted () {
      const me = this
      const id = me.$route.params.id
      me.$http.get('/api/admin/liquidaciones/clientes/detalle', {
        params: {
          id: id
        }
      }).then(({body}) => {
        let liquidacion = body.liquidacion
        liquidacion.entregas.forEach((entrega) => {
          entrega.verDetalle = false
        })
        me.liquidacion = liquidacion
        me.movimientos = body.movimientos
      }, (err) => {
        console.error(err)
      }).then(() => {
        $(me.$refs.slUsuario).select2({
          placeholder: 'Seleccione un usuario'
        }).on('change', (e) => {
          me.filtros.empleados = $(me.$refs.slUsuario).val()
        })
        $(me.$refs.slCombo).select2({
          placeholder: 'Seleccione un Combo'
        }).on('change', (e) => {
          me.filtros.combos = $(me.$refs.slCombo).val()
        })
        $.datepicker.setDefaults($.datepicker.regional['es'])
        $('.datepicker.desde').datepicker({
          dateFormat: 'dd/mm/yy',
          beforeShowDay: $.datepicker.noWeekends
        }).datepicker('setDate', moment().add(-30, 'days').toDate())
        $('.datepicker.hasta').datepicker({
          dateFormat: 'dd/mm/yy',
          beforeShowDay: $.datepicker.noWeekends
        }).datepicker('setDate', moment().add(-1, 'days').toDate())
      })
      $(document).ready(() => {
        $('body').on('click', '.js-detalle', (e) => {
          var $btn = $(e.target)
          $btn.parentsUntil('tbody').next('.table-detalle').toggleClass('hidden')
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// DetalleLiquidacionCliente.vue?976c9a7a